import React from 'react';

function Intro() {
  return (
    <div className="intro">
      <h1 className="title">Project Stable</h1>
      <h4 className="subtitle page-subtitle">
        Project Stable is a global, decentralized, on-chain, price history and inflation dashboard.
        <br />
        Track price changes of daily-use products and services in various categories across multiple countries.
      </h4>
    </div>
  );
}

export default Intro;
